import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';


export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "汗汗漫画网的漫画都是免费的吗？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "是的，汗汗漫画网所有漫画均为免费阅读。我们致力于为广大漫画爱好者提供优质的韩国漫画资源，无需付费即可享受完整版的阅读体验。"
                }
              },
              {
                "@type": "Question",
                "name": "什么是下拉式阅读？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "下拉式阅读是一种创新的漫画浏览方式，读者只需向下滑动页面即可连续阅读漫画内容，无需点击翻页按钮。这种方式更加流畅自然，尤其适合在手机上阅读。"
                }
              },
              {
                "@type": "Question",
                "name": "漫画是完整版无删减的吗？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "我们平台的所有漫画均为原版引进的完整版，无删减、无遮挡，确保读者能够体验到最原汁原味的漫画内容。"
                }
              },
              {
                "@type": "Question",
                "name": "支持哪些设备阅读？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "汗汗漫画网采用响应式设计，完美适配PC电脑、平板和手机等多种设备。无论您使用什么设备，都能获得流畅的下拉式阅读体验。"
                }
              },
              {
                "@type": "Question",
                "name": "漫画更新频率如何？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "我们与韩国漫画平台保持同步更新，热门漫画通常每周更新1-2话，确保读者能够及时追更最新内容。"
                }
              }
            ]
          }),
        }}
      />
      <Navbar />
      <main className="pt-16">
        <nav className="bg-background-50 border-b border-background-200/70" aria-label="面包屑导航">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
            <ol className="flex items-center gap-2 text-xs text-foreground-500">
              <li><Link to="/" className="hover:text-primary-600 transition-colors">首页</Link></li>
              <li><i className="ri-arrow-right-s-line text-xs"></i></li>
              <li><span className="text-foreground-800 font-medium">关于我们</span></li>
            </ol>
          </div>
        </nav>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading text-center mb-4">
              关于汗汗漫画网
            </h1>
            <p className="text-foreground-500 text-center max-w-xl mx-auto">
              无删减韩国漫画<strong>下拉式免费阅读</strong>平台
            </p>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-6">品牌介绍</h2>
            <div className="bg-background-50 rounded-xl p-6 md:p-8">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                <strong>汗汗漫画网</strong>成立于2020年，是一家专注于为中文读者提供<strong>高质量韩国漫画完整版</strong>的在线阅读平台。我们深知漫画爱好者对「<strong>无删减</strong>」和「<strong>完整版</strong>」的追求，因此平台所有漫画均为原版引进、无删减无遮挡，确保每一部作品的完整呈现。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                我们采用创新的<strong>下拉式阅读</strong>模式，打破了传统翻页的局限，让读者可以像浏览网页一样顺畅地阅读漫画。只需<strong>下拉观看</strong>，即可沉浸在连贯的漫画世界中，无需点来点去，操作简单直观。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                目前平台已收录超过<strong>500部韩国漫画</strong>，涵盖恋爱、奇幻、动作、悬疑、搞笑、都市、BL、古风、校园等多个分类，每日更新，内容丰富。无论您是喜欢甜宠恋爱的少女心读者，还是热爱热血战斗的少年漫画迷，都能在这里找到心仪的作品。
              </p>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-6">用户口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  name: '漫画迷小王',
                  text: '汗汗漫画真的是我见过最好的漫画网站！下拉式阅读超级方便，再也不用点来点去了。而且真的是无删减完整版，画质也很高清！',
                  rating: 5,
                  date: '2026-07-28',
                },
                {
                  name: '爱看漫画的小李',
                  text: '追了两年多的《全知读者视角》在这里找到了完整版，太感动了！更新也很快，基本和韩国同步，强烈推荐！',
                  rating: 5,
                  date: '2026-07-25',
                },
                {
                  name: '漫画狂热者',
                  text: '收藏了！分类很全，找漫画很方便。关键是免费阅读，而且没有乱七八糟的弹窗广告，阅读体验很纯净。',
                  rating: 5,
                  date: '2026-07-20',
                },
                {
                  name: '每日一漫',
                  text: '每天通勤路上都在汗汗看漫画，下拉式在手机上体验也超好。韩国漫画的画风和故事真的上瘾！',
                  rating: 5,
                  date: '2026-07-15',
                },
                {
                  name: '漫无止境',
                  text: '朋友推荐来的，一用就停不下来了。漫画资源真的多，而且每部都是完整版，不用到处找资源了。',
                  rating: 4,
                  date: '2026-07-10',
                },
                {
                  name: '追更少女',
                  text: '《某天成为公主》和《社内相亲》在这里找到了无删减版，画质比别的网站好太多了！更新也快，爱了爱了！',
                  rating: 5,
                  date: '2026-07-05',
                },
              ].map((review, i) => (
                <div key={i} className="bg-background-100 rounded-xl p-5 flex flex-col">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i
                        key={j}
                        className={`text-sm ${j < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed flex-1 mb-3">
                    &ldquo;{review.text}&rdquo;
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium text-foreground-800">{review.name}</span>
                    <span className="text-xs text-foreground-400">{review.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-6">联系我们</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-background-50 rounded-xl p-6 md:p-8">
                <h3 className="text-base font-semibold text-foreground-900 mb-4">联系方式</h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                      <p className="text-sm font-medium text-foreground-800">contact@hanhancomic.com</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 shrink-0">
                      <i className="ri-wechat-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">微信公众号</p>
                      <p className="text-sm font-medium text-foreground-800">汗汗漫画网</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 shrink-0">
                      <i className="ri-customer-service-2-line text-secondary-700"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">客服QQ群</p>
                      <p className="text-sm font-medium text-foreground-800">9527XXXXX</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="bg-background-50 rounded-xl p-6 md:p-8">
                <h3 className="text-base font-semibold text-foreground-900 mb-4">给我们留言</h3>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-6">常见问题</h2>
            <div className="space-y-3">
              {[
                {
                  q: '汗汗漫画网的漫画都是免费的吗？',
                  a: '是的，汗汗漫画网所有漫画均为免费阅读。我们致力于为广大漫画爱好者提供优质的韩国漫画资源，无需付费即可享受完整版的阅读体验。',
                },
                {
                  q: '什么是下拉式阅读？',
                  a: '下拉式阅读是一种创新的漫画浏览方式，读者只需向下滑动页面即可连续阅读漫画内容，无需点击翻页按钮。这种方式更加流畅自然，尤其适合在手机上阅读。',
                },
                {
                  q: '漫画是完整版无删减的吗？',
                  a: '我们平台的所有漫画均为原版引进的完整版，无删减、无遮挡，确保读者能够体验到最原汁原味的漫画内容。',
                },
                {
                  q: '支持哪些设备阅读？',
                  a: '汗汗漫画网采用响应式设计，完美适配PC电脑、平板和手机等多种设备。无论您使用什么设备，都能获得流畅的下拉式阅读体验。',
                },
                {
                  q: '漫画更新频率如何？',
                  a: '我们与韩国漫画平台保持同步更新，热门漫画通常每周更新1-2话，确保读者能够及时追更最新内容。',
                },
              ].map((faq, i) => (
                <details key={i} className="group bg-background-100 rounded-xl">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                    <i className="ri-add-line text-foreground-400 group-open:hidden shrink-0"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');

    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }

    try {
      const formData = new FormData(form);
      const response = await fetch(contactFormUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      if (response.ok) {
        try {
          const parsed = JSON.parse(responseText);
          if (parsed?.code === 'OK') {
            setSubmitted(true);
            form.reset();
          } else {
            setError(parsed?.meta?.message || parsed?.meta?.detail || '提交失败，请稍后重试');
          }
        } catch {
          setSubmitted(true);
          form.reset();
        }
      } else {
        let serverMsg = responseText || '提交失败，请稍后重试';
        try {
          const parsed = JSON.parse(responseText);
          if (parsed?.meta?.message?.includes('spam') || parsed?.meta?.detail?.includes('spam')) {
            serverMsg = '提交失败，请稍后重试';
          } else {
            serverMsg = parsed?.meta?.message || parsed?.meta?.detail || serverMsg;
          }
        } catch {
          // ignore parse error, use responseText as is
        }
        setError(serverMsg);
      }
    } catch {
      setError('网络异常，请检查网络连接后重试');
    }
  };

  const contactFormUrl = 'https://readdy.ai/api/form/d9pf18ub4qjhggaepsug';

  if (submitted) {
    return (
      <div className="text-center py-8">
        <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
          <i className="ri-check-line text-2xl text-accent-600"></i>
        </div>
        <p className="text-sm font-medium text-foreground-800 mb-1">留言已发送！</p>
        <p className="text-xs text-foreground-500">感谢您的反馈，我们会尽快回复</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} data-readdy-form="">
      {error && (
        <div className="mb-3 p-3 rounded-lg bg-red-50 text-red-600 text-xs">{error}</div>
      )}
      <div className="space-y-3">
        <input
          type="text"
          name="name"
          required
          placeholder="您的昵称"
          className="w-full text-sm px-4 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-all"
        />
        <input
          type="email"
          name="email"
          required
          placeholder="您的邮箱"
          className="w-full text-sm px-4 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-all"
        />
        <textarea
          name="message"
          required
          maxLength={500}
          rows={4}
          placeholder="请输入您的留言（最多500字）"
          className="w-full text-sm px-4 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-all resize-none"
        ></textarea>
        <input
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="form-honeypot"
        />
        <button
          type="submit"
          className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer"
        >
          发送留言
        </button>
      </div>
    </form>
  );
}